'use strict';

/*
 * layout action types (GLOBAL)
 */
var SET_ACTIVE_SECTION = 'SET_ACTIVE_SECTION';
var SET_ACTIVE_URI = 'SET_ACTIVE_URI';
var SET_ACTIVE_FLOW = 'SET_ACTIVE_FLOW';

/*
 * other constants
 */
var Sections = {
  HOME: 'Dashboard',
  LOANS: 'Loans',
  WEALTH: 'Wealth',
  CRYPTO: 'Bitcoin',
  CREDITSCORE: 'Credit Score',
  MORTGAGE: 'Mortgage',
  CARD: 'Card',
  ACCOUNT: 'Account'
};

function _LayoutReducers() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [];

  this.init = function () {};
  this.initAllReady = function () {};

  var initialLayoutState = {};

  function updateActiveSectionObject(stateData, id) {
    return updateObject(stateData, {
      active_section: id,
      active_section_title: Sections[id]
    });
  }

  function updateURIObject(stateData, payload) {
    return updateObject(stateData, {
      current_uri: payload.current_uri,
      previous_uri: payload.previous_uri
    });
  }

  function updateActiveFlowObject(stateData, id) {
    return updateObject(stateData, {
      active_flow: id
    });
  }

  function layoutReducer(state, action) {
    switch (action.type) {
      case SET_ACTIVE_SECTION:
        return updateActiveSectionObject(state, action.payload.section_id);
      case SET_ACTIVE_URI:
        return updateURIObject(state, action.payload);
      case SET_ACTIVE_FLOW:
        return updateActiveFlowObject(state, action.payload.flow_id);
      default:
        return state;
    }
  }

  this.layoutReducer = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialLayoutState;
    var action = arguments[1];

    return layoutReducer(state, action);
  };
}